/* eslint-disable */
import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import queryString from 'query-string';
import dayjs from "utils/dayjs"

import { Box, Button, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { DataGridPro, koKR, enUS, zhCN  } from '@mui/x-data-grid-pro';
import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput, orderNumber, ROLE } from 'data/data';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import { getEquipmentsByQuery, getEquipmentsGroupCountByStatus } from 'components/axios/equipmentAxios';
import PageInfo from 'components/PageInfo';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import InspectionModal from 'components/modal/InspectionModal';
import MaintenanceTaskAndAlertModal from 'components/modal/MaintenanceTaskAndAlertModal';
// import CommonExcelDownload from "components/CommonExcelDownload";
import { getSearchFiltersEquipmentZones } from 'components/axios/equipmentZoneAxios';
import CommonLargeExcelDownload from 'components/CommonLargeExcelDownload';
import useConfig from 'hooks/useConfig';
import usePermission from 'hooks/usePermission';
import { PERMISSIONS } from 'config/permissions';
import { getCompaniesByQuery } from 'components/axios/companyAxios';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const EquipmentMonitoring = () => {
    const isViewCommError = process.env.REACT_APP_SHOW_NETWORK_ERROR_TO_ALL_YN;
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s, role, loginInfo } = useEnumApi();
    const { t, i18n } = useTranslation();
    const { mode } = useConfig();
    const location = useLocation();
    const navigate = useNavigate();

    const COMM_STATUS_LIST = [
      { id: 'N', value: false,  name: t('message.common.normal') },
      { id: 'Y', value: true,   name: t('message.common.subtitle.communication.issue') },
    ];

    const COMM_STATUS_MAP = COMM_STATUS_LIST.reduce((acc, item) => {
      acc[item.value] = item.name;
      return acc;
    }, {});

    const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
    const nantongCompanyId = process.env.REACT_APP_NANTONG_MANAGEMENT_COMPANY_NO;
    const lang = i18n.language.substring(0, 2);
    
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    const [equipments, setEquipments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    const [toggleStr, setToggleStr] = useState(true);
  
    const [zoneCategoryCode, setZoneCategoryCode] = useState('');
    const [stationId, setStationId] = useState('');
    const [managementCompanyId, setManagementCompanyId] = useState('');
    const [zoneId, setZoneId] = useState('');
    const [deadIotDevice, setDeadIotDevice] = useState('');
    
    const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
    const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
  
    const [managementCompanies, setManagementCompanies] = useState([]);
    const [zoneCategories, setZoneCategories] = useState([]);
    const [zones, setZones] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  
    const [sortModel, setSortModel] = useState(null);
    const excelTitle = t('menu.cmms.equipment');
    const excelTopHeaders = [
      'No.'
      , t('message.common.subtitle.equipment.status')
      , t('message.common.subtitle.iot.status')
      , t('message.common.subtitle.recent.diagnosis') 
      , getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title
      , t('message.common.subtitle.zone')
      , getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title
      , t('message.common.subtitle.equipment.level1')
      , t('message.common.subtitle.equipment.level3')
      , t('message.common.subtitle.equipment.name')
      , t('message.common.subtitle.equipment.number')
      , getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title 
      , t('message.common.subtitle.modelName') 
      , t('message.common.subtitle.position')
    ];
    const [excelParam, setExcelParam] = useState([]);
    // const fileName = excelTitle+"_"+Date.now();
    // const [excelDatas, setExcelDatas] = useState([]);

    if (platformServer === 'NANTONG') {
      excelTopHeaders.splice(4, 3)

      // 호선, 역사 추가
      excelTopHeaders.splice(3, 0, t('message.common.subtitle.subwayline')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      excelTopHeaders.splice(4, 0, t('message.common.subtitle.station')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    }

    if (!isViewCommError && role !== ROLE.SA.code) {
      excelTopHeaders.splice(2, 1);
    }
    
    // const connectProblemDay = dayjs.tz(process.env.REACT_APP_TIMEZONE).subtract(7, "day").format(t('message.common.text.date.format.date'));
    // 디버깅용 로그 추가
    // if (!ready) return null;

    // const dateFormat = t('message.common.text.date.format.date');
    // console.log("Date Format:", dateFormat); // 이게 정상적인 포맷(예: 'YYYY-MM-DD')인지 확인하세요.

    // const connectProblemDay = dayjs
    //   .tz(process.env.REACT_APP_TIMEZONE)
    //   .subtract(7, "day")
    //   .format(dateFormat || "YYYY-MM-DD"); // 폴백(fallback) 포맷 설정

    const requestRefresh = useCallback(() => {
      setIsLoading(false)
    }, []);
  
    // const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);
    const searchFields = [
      {code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}, {code:"modelName", title:t('message.common.subtitle.modelName')}
      // , {code:"mfr", title:getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title}, {code:"man", title:getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title}, {code:"mnt", title:getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title}
    ];
  
    let qs = queryString.parse(location.search);
    let falutStatusSelectColor = "";
    
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');
  
    if (equipmentFaultStatus === '' || equipmentFaultStatus === "sum") {
      falutStatusSelectColor = " selected";
    }
    
    let columns = [
      { field: 'status', headerName: t('message.common.subtitle.equipment.status'), sortable:true, width: 100, cellClassName : 'statusButton'
        , renderCell:(params)=>(
          <div style={{textAlign:"center"}} className={params.row?.status}>
              <Link to={'/equipment/'+params.row?.id+searchParamString}>
                {getEnumValueByEnumNameAndCode("EquipmentFaultStatus", params.row?.status)?.[0]?.title}
              </Link>
          </div>)
      },
      { field: 'hasCommunicationIssue', headerName: t('message.common.subtitle.iot.status'), sortable:false, width: 80,
        cellClassName : 'statusButton'
        , renderCell:(params)=>(
          <div style={{textAlign:"center"}} className={(params.row?.hasCommunicationIssue ? 'condition4' : 'condition6')}>
            <Link to={'/equipment/'+params.row?.id+searchParamString}>{COMM_STATUS_MAP[params.row?.hasCommunicationIssue]}</Link>
          </div>)
      },
      { field: 'latestCommYmd', headerName: t('message.common.subtitle.recent.diagnosis'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.latestCommYmd}</Link>)
      },
      
      { field: 'managementCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title, sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.managementCompany?.info?.name}</Link>)
      },
      { field: 'zone.name', headerName: t('message.common.subtitle.zone'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.zone?.name}</Link>)
      },
      { field: 'maintenanceCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MNT')?.[0]?.title, sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.maintenanceCompany?.info?.name}</Link>)
      },
      { field: 'equipmentCtgr.parent.parent.name', headerName: t('message.common.subtitle.equipment.level1'), sortable:true,  width: 100
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.parent?.parent?.name}</Link>)
      },
      
      { field: 'equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.name}</Link>)
      },
      { field: 'name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.name}</Link>)
      },
      { field: 'equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentNo}</Link>)
      },
      { field: 'manufacturingCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MFR')?.[0]?.title, sortable:true, width: 150
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.manufacturingCompany?.info?.name}</Link>)
      },
      { field: 'modelName', headerName: t('message.common.subtitle.modelName'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.modelName}</Link>)
      },
      { field: 'location', headerName: t('message.common.subtitle.position'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.location}</Link>)
      },
      {
        field: 'alertRequest', headerName: t('message.common.subtitle.alertRequest'), sortable:false, width: 100
        , renderCell:(params)=>(<div style={{textAlign:"center", width:"100%"}}><InspectionModal id={params.row?.id} onRefresh={requestRefresh} type="icon" /></div>)
      }
    ];

    if (platformServer === 'NANTONG') {
      // 관리주체 항목 제거
      const targetIndex = columns.findIndex(item => item.field === 'managementCompany.info.name');
      if (targetIndex !== -1) {
        columns.splice(targetIndex, 3); // targetIndex부터 3개를 삭제
      }

      // 호선, 역사 추가
      const newItem = { field: 'zone.category.code', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 80
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.zone?.category?.name?.[i18n.language.substring(0, 2)]}</Link>)
      };
      const newItem2 = { field: 'zone.name', headerName: t('message.common.subtitle.station'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.zone?.name}</Link>)
      };
      columns.splice(2, 0, newItem); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      columns.splice(3, 0, newItem2); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    }

    if (!isViewCommError && role !== ROLE.SA.code) {
      columns.splice(1, 1);
    }

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "opStatus,asc"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
  
        if (qs.searchOpStatus) setEquipmentOpStatus(qs.searchOpStatus);
        if (qs.searchStatus) setEquipmentFaultStatus(qs.searchStatus);
        if (qs.searchSubway) setZoneCategoryCode(qs.searchSubway);
        if (qs.searchStation) setStationId(qs.searchStation);
        if (qs.searchManagementCompanyId) setManagementCompanyId(qs.searchManagementCompanyId);
        if (qs.searchZone) setZoneId(qs.searchZone);
        if (qs.searchDeadIotDevice) setDeadIotDevice(qs.searchDeadIotDevice);
        if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
        if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
        if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchOpStatus) {searchParamCopy.searchOpStatus = qs.searchOpStatus};
        if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
        if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
        if (qs.searchManagementCompanyId) {searchParamCopy.searchManagementCompanyId = qs.searchManagementCompanyId};
        if (qs.searchZone) {searchParamCopy.searchZone = qs.searchZone};
        if (qs.searchDeadIotDevice) {searchParamCopy.searchDeadIotDevice = qs.searchDeadIotDevice};
        if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
        if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
        if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>orders.push({sort:order}));
            qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [location.search]);
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchOpStatus, qs.searchStatus, qs.searchSubway
      , qs.searchWorkingPart, qs.searchStation, qs.searchZone, qs.searchManagementCompanyId, qs.searchDeadIotDevice, qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

    // 관리주체목록
    useEffect(()=>{
      if (platformServer !== 'NANTONG') {
        const param = { "type": "MAN", size : 100, sort : "info.name,asc" };
        getCompaniesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded?.companies?.map(item => {return { ...item, name: item.info?.name }});
            if (list) {
              setManagementCompanies(list);
            } else {
              setManagementCompanies([]);
            }
          } else {
            setManagementCompanies([]);
          }
        });
      }
    },[]);

    // 관리주체의 구역목록
    useEffect(()=>{
      if (managementCompanyId) {
        const equipmentZones = managementCompanies?.find(zc=>zc.id == managementCompanyId)?.equipmentZones;
        setZones(equipmentZones ?? [])
      } else {
        setZones([])
      }
    },[managementCompanyId, managementCompanies])

    // 난퉁의 호선목록
    useEffect(() => {
      const fetchAndSetZones = async () => {
        const data = await getSearchFiltersEquipmentZones();
        if (!data) return;

        const company = data.managementCompanies?.find(com => com.id == nantongCompanyId);
        if (company) {
          const categories = company.zoneCategories?.map(zc => ({
            ...zc,
            title: zc.name?.[lang]
          })) ?? [];
          
          setZoneCategories(categories);

          // 카테고리 로드 직후, 현재 선택된 zoneCategoryCode가 있다면 바로 zones까지 세팅
          if (zoneCategoryCode) {
            const foundCategory = categories.find(zc => zc.code === zoneCategoryCode);
            setZones(foundCategory?.zones ?? []);
          }
        }
      };

      fetchAndSetZones();
    }, [nantongCompanyId, lang, zoneCategoryCode]); // 관련 의존성을 통합

    // 난퉁의 역사목록
    useEffect(()=>{
      if (platformServer === 'NANTONG') {
        if (zoneCategoryCode) {
          const zonCategory = zoneCategories?.find(zc=>zc.code === zoneCategoryCode);
          setZones(zonCategory?.zones ?? [])
          // console.log(zonCategory)
          // console.log(zonCategory?.zones ?? [])
        } else {
          setZones([])
        }
      }
    },[zoneCategoryCode])

    // 설비중분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel1Id) {
        const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel2s(list);
            } else {
              setEquipmentCategoryLevel2s([]);
            }
          } else {
            setEquipmentCategoryLevel2s([]);
          }
          setEquipmentCategoryLevel3s([]);
        });
      }
    },[equipmentCategoryLevel1Id]);
  
    // 설비분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel2Id) {
        const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel3s(list);
            } else {
              setEquipmentCategoryLevel3s([]);
            }
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        });
      }
    },[equipmentCategoryLevel2Id]);
  
    // 목록
    useEffect(()=> {
      if (!isParam) return;

      equipmentList();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      currentPage,
      pageSize,
      location.search,
      equipmentFaultStatus,
      i18n.language,
      getEnumValueByEnumName("EquipmentFaultStatus"),
      isParam,
      sortModel
    ]);

    let [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
    let [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
  
    const equipmentList = (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
      setCurrentPage(curPage)
  
      const urlSearchStatus = qs.searchStatus;
      const status = urlSearchStatus || equipmentFaultStatus;

      let param = {
        page : curPage,
        size : pageSize,
        iotInstlYn : true,
        opStatus : "O"
      };
      let countParam = {...param};

      if (equipmentOpStatus) {
        param.opStatus = equipmentOpStatus;
      }
      if (zoneCategoryCode) {
        param["zone.category.code"] = zoneCategoryCode;
      }
      if (stationId) {
        param['zone.id'] = stationId;
      }
      if (managementCompanyId) {
        param['managementCompany.id'] = managementCompanyId;
      }
      if (zoneId) {
        param['zone.id'] = zoneId;
      }
      if (deadIotDevice) {
        param['hasDeadIotDeviceYn'] = deadIotDevice;
      }
      if (equipmentCategoryLevel1Id) {
        param['equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
      }
      if (equipmentCategoryLevel2Id) {
        param['equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
      }
      if (equipmentCategoryLevel3Id) {
        param['equipmentCtgr.id'] = equipmentCategoryLevel3Id;
      }
      // if (equipmentFaultStatus === 'problem') {
      //   const connectProblemDay = dayjs.tz(process.env.REACT_APP_TIMEZONE).subtract(7, "day").format(t('message.common.text.date.format.date'));
      //   param.latestCommYmd = 'lte('+connectProblemDay+')';
      // } else {
      //   if (equipmentFaultStatus !== 'sum')
      //     param.status = equipmentFaultStatus;
      //   let keyword = searchKeyword;
      if (status === 'problem') {
        const connectProblemDay = dayjs.tz(process.env.REACT_APP_TIMEZONE)
          .subtract(7, "day")
          .format(t('message.common.text.date.format.date'));

        param.latestCommYmd = 'lte('+connectProblemDay+')';
      } else {
        if (status && status !== 'sum') {
          param.status = status;
        }

        let keyword = searchKeyword;
        if (searchKeyword) {
          if (!searchField) {
            setSearchField('name')
            keyword = 'contains('+searchKeyword+')';
            param.name = keyword;
          } else {
            if (searchField && (searchField === 'name' || searchField === 'equipmentNo' )) {
              keyword = 'contains('+searchKeyword+')';
            }
  
            if (searchField === 'name') {
              param.name = keyword;
            } else if (searchField === 'equipmentNo') {
              param.equipmentNo = keyword;
            } else if (searchField === 'modelName') {
              param.modelName = keyword;
            }
          }
        }
      }
      if (sortModel && sortModel.length > 0)
        param.sort = sortModel[0].field+","+sortModel[0].sort;
      else
        param.sort = "opStatus,asc";

      const { page, size, ...rest } = param;
      setExcelParam(rest);

      Promise.all([
        getEquipmentsByQuery(param).then((data)=>{
          if (data != null) {
            if(data.page) {
              setPageInfo(data.page);
            } else {
              setCurrentPage(0);
              pageInfo = {
                size : pageInfo.size,
                totalElements : 0,
                totalPages : 0,
                number : 0
              }
              setPageInfo(pageInfo);
            }
            if(data._embedded) {
              let list = data._embedded.equipments;
              setEquipments(list);
              setIsLoading(true);
              return data.page.totalElements;
            } else {
              setEquipments([]);
            }
          } else {
            pageInfo = {
              size : pageInfo.size,
              totalElements : 0,
              totalPages : 0,
              number : 0
            }
            setPageInfo(pageInfo);
            setEquipments([]);
          }
          setIsLoading(true);
          return 0;
        }),
        getEquipmentsGroupCountByStatus(countParam).then((res)=>{
          equipmentGroupCounts = [];
          totalEquipmentGroupCount = 0;
          if (res != null) {
            let isInclude = false;
    
            let equipmentFaultStatuss = getEnumValueByEnumName("EquipmentFaultStatus");
            if (equipmentFaultStatuss) {
                equipmentFaultStatuss.map(status => status.code === 'O4_C' ? status.sort = 4 : '')
                equipmentFaultStatuss.map(status => status.code === 'O3_A' ? status.sort = 3 : '')
                equipmentFaultStatuss.map(status => status.code === 'O2_I' ? status.sort = 2 : '')
                equipmentFaultStatuss.map(status => status.code === 'O1_N' ? status.sort = 1 : '')
                orderNumber(equipmentFaultStatuss, "sort")
  
                equipmentFaultStatuss.map(function(item1) {
                  if (item1.code !== 'O4_C') {
                  isInclude = false;
                  res.data.map(function(item2) {
                    if (item2.groups.includes(item1.code)) {
                      equipmentGroupCounts.push(...[{
                        name : item1.code,
                        id : item1.code,
                        title : item1.title,
                        count : item2.count,
                      }]);
                      totalEquipmentGroupCount += item2.count;
                      isInclude = true;
                    }
                  })
      
                  if (!isInclude) {
                    let defaultStatus = [{
                      name : item1.code,
                      id : item1.code,
                      title : item1.title,
                      count : 0,
                    }];
                    equipmentGroupCounts.push(...defaultStatus);
                  }
                }
              })
            }
            setEquipmentGroupCounts(equipmentGroupCounts);
            setTotalEquipmentGroupCount(totalEquipmentGroupCount);
          }
        })
      ])
     
      setIsLoading(true);
    }

    const dataMappingRules = (column, index, totalElements, startIndex) => {
      const rowNumber = totalElements - (startIndex + index);

      let rowData = [
        rowNumber,
        (((getEnumValueByEnumNameAndCode("EquipmentFaultStatus", column.status)?.[0]?.title) || '')),
        (((COMM_STATUS_MAP[column.hasCommunicationIssue]) || '')),
        ((column.latestCommYmd) || ''),
        ((column.managementCompany?.info?.name) || ''),
        ((column.zone?.name) || ''),
        ((column.maintenanceCompany?.info?.name) || ''),
        ((column.equipmentCtgr?.parent?.parent?.name) || ''),
        ((column.equipmentCtgr?.name) || ''),
        ((column.name) || ''),
        ((column.equipmentNo) || ''),
        ((column.manufacturingCompany?.info?.name) || ''),
        ((column.modelName) || ''),
        ((column.location) || '')
      ];

      if (platformServer === 'NANTONG') {
        rowData.splice(4, 3)

        // 호선, 역사 추가
        rowData.splice(3, 0, column?.zone?.category?.name?.[i18n.language.substring(0, 2)]); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
        rowData.splice(4, 0, column?.zone?.name); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
      }

      if (!isViewCommError && role !== ROLE.SA.code) {
        rowData.splice(2, 1);
      }

      return rowData;
    };
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
 
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      equipmentList(0);
      // setExcelDatas([]);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (equipmentOpStatus) {searchParamCopy.searchOpStatus = equipmentOpStatus};
      if (equipmentFaultStatus) {searchParamCopy.searchStatus = equipmentFaultStatus};
      if (zoneCategoryCode) {searchParamCopy.searchSubway = zoneCategoryCode};
      if (stationId) {searchParamCopy.searchStation = stationId};
      if (managementCompanyId) {searchParamCopy.searchManagementCompanyId = managementCompanyId};
      if (zoneId) {searchParamCopy.searchZone = zoneId};
      if (deadIotDevice) {searchParamCopy.searchDeadIotDevice = deadIotDevice};
      if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
      if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
      if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    const handleMobileOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleMobileSearch = (event) => {
      handleSearch(event);
      handleClose();
    };
  
    const statusTapSearch = (vCode) => {
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      setEquipmentFaultStatus(vCode);
      initSearch();

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      searchParamCopy.searchStatus = vCode;
      searchParamCopy.searchKeyword = '';
      searchParamCopy.searchOpStatus = '';
      searchParamCopy.searchSubway = '';
      searchParamCopy.searchStation = '';
      searchParamCopy.searchManagementCompanyId = '';
      searchParamCopy.searchZone = '';
      searchParamCopy.searchDeadIotDevice = '';
      searchParamCopy.searchlevel1 = '';
      searchParamCopy.searchlevel2 = '';
      searchParamCopy.searchlevel3 = '';
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };
  
    const initSearch = ()  => {
      setEquipmentOpStatus('');
      setZoneCategoryCode('');
      setStationId('');
      setManagementCompanyId('');
      setZoneId('');
      setDeadIotDevice('');
      setEquipmentCategoryLevel1Id('');
      setEquipmentCategoryLevel2Id('');
      setEquipmentCategoryLevel3Id('');
      setToggleStr(!toggleStr);
      setSearchKeyword('');
      setCurrentPage(0);
      setIsLoading(false);
      // setExcelDatas([]);
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        setOpen(false);
      }
    };

    const { hasPermission } = usePermission();
    const equipmentCategorySearchPermission = hasPermission(PERMISSIONS.EQUIPMENT_CATEGORY_SEARCH);
  
    // if (isLoading) {
    return (
      <div className="sub_container">
        <div className='search_section'>
          <ul className='condition' style={{marginTop:"px"}}>
            <li>{t('message.common.subtitle.equipment.status')}</li>
            <li className={`sum${falutStatusSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.total')}: {totalEquipmentGroupCount}</li>
            {equipmentGroupCounts &&
              equipmentGroupCounts.map(function(item, i) {
                falutStatusSelectColor = "";
                if (item.id === equipmentFaultStatus) {
                  falutStatusSelectColor = " selected";
                }
                let addTitle = '';
                // if (item.id === 'O9_G')
                //   addTitle = 'ISO(A)';
                // else if (item.id === 'O7_N')
                //   addTitle = 'ISO(B)';
                // else if (item.id === 'O5_D')
                //   addTitle = 'ISO(C)';
                // else if (item.id === 'O1_F')
                //   addTitle = 'ISO(D)';
                return (
                  <li key={i} className={`${item.id}${falutStatusSelectColor}`} onClick={() => statusTapSearch(item.id)} style={{cursor:"pointer"}}>{addTitle == '' && item.title}{addTitle}: {item.count}</li>      
                )
              }) }
          </ul>
          
          <div className='selectbox'>
            <div className="desktop_serach">
              <Box component="form">
                <div>
                  <div>
                    {(platformServer === 'NANTONG' && zoneCategories) &&
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomEnumSelect
                        key={zoneCategoryCode}
                        label={t('message.common.subtitle.subwayline')}
                        labelName={t('message.common.subtitle.subwayline')}
                        name={'subway'}
                        defaultValue={zoneCategoryCode}
                        onChange={(e)=>{
                          setZoneCategoryCode(e.target.value);
                          setStationId('')
                        }}
                        list={zoneCategories}
                    />
                    </FormControl>
                    }
                    {(platformServer === 'NANTONG' && zones ) && (
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={stationId}
                        label={t('message.common.subtitle.station')}
                        labelName={t('message.common.subtitle.station')}
                        name={'station'}
                        value={stationId}
                        onChange={(e)=>{
                          setStationId(e.target.value)
                        }}
                        list={zones}
                    />
                    </FormControl>
                    )}
                    {(platformServer !== 'NANTONG' && managementCompanies) &&
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={managementCompanyId}
                        label={getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}
                        labelName={getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title}
                        name={'managementCompanyId'}
                        defaultValue={managementCompanyId}
                        onChange={(e)=>{
                          setManagementCompanyId(e.target.value);
                          setZoneId('')
                        }}
                        list={managementCompanies}
                    />
                    </FormControl>
                    }
                    {(platformServer !== 'NANTONG' && zones ) && (
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={zoneId}
                        label={t('message.common.subtitle.zone')}
                        labelName={t('message.common.subtitle.zone')}
                        name={'zoneId'}
                        defaultValue={zoneId}
                        onChange={(e)=>{
                          setZoneId(e.target.value)
                        }}
                        list={zones}
                    />
                    </FormControl>
                    )}
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={`deadIotDevice-${deadIotDevice}`}
                        label={t('message.common.subtitle.iot.status')}
                        labelName={t('message.common.subtitle.iot.status')}
                        name={'deadIotDevice'}
                        value={deadIotDevice}
                        onChange={(e)=>{
                          setDeadIotDevice(e.target.value)
                        }}
                        list={COMM_STATUS_LIST}
                    />
                    </FormControl>
                    {equipmentCategorySearchPermission && equipmentCategoryLevel1s && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={equipmentCategoryLevel1Id}
                        label={t('message.common.subtitle.equipment.level1')}
                        labelName={t('message.common.subtitle.equipment.level1')}
                        name={'level1'}
                        defaultValue={equipmentCategoryLevel1Id}
                        onChange={(e)=>{
                          setEquipmentCategoryLevel1Id(e.target.value);
                          setEquipmentCategoryLevel2Id('');
                          setEquipmentCategoryLevel3Id('');
                        }}
                        list={equipmentCategoryLevel1s}
                    />
                    </FormControl>
                    }
                    {equipmentCategorySearchPermission && equipmentCategoryLevel2s && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={equipmentCategoryLevel2Id}
                        label={t('message.common.subtitle.equipment.level2')}
                        labelName={t('message.common.subtitle.equipment.level2')}
                        name={'level2'}
                        defaultValue={equipmentCategoryLevel2Id}
                        onChange={(e)=>{
                          setEquipmentCategoryLevel2Id(e.target.value);
                          setEquipmentCategoryLevel3Id('');
                        }}
                        list={equipmentCategoryLevel2s}
                    />
                    </FormControl>
                    }
                    {equipmentCategorySearchPermission && equipmentCategoryLevel3s && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomSelect
                        key={equipmentCategoryLevel3Id}
                        label={t('message.common.subtitle.equipment.level3')}
                        labelName={t('message.common.subtitle.equipment.level3')}
                        name={'level3'}
                        defaultValue={equipmentCategoryLevel3Id}
                        onChange={(e)=>{
                          setEquipmentCategoryLevel3Id(e.target.value);
                        }}
                        list={equipmentCategoryLevel3s}
                    />
                    </FormControl>
                    }
                    <div style={{display:"inline-block"}}>
                    {searchFields && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomEnumSelect
                        key={searchField}
                        label={t('message.common.btn.search')}
                        labelName={t('message.common.btn.search')}
                        name={'searchField'}
                        defaultValue={searchField}
                        onChange={(e)=>{
                          setSearchField(e.target.value);
                        }}
                        list={searchFields}
                    />
                    </FormControl>
                    }
                      <FormControl sx={{ m: 1 }} variant="standard">
                        <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword || ''} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                      </FormControl>
    
                      <Button className='search_icon1' variant="contained" style={{marginTop:"0",padding:"12px 15px"}} onClick={handleSearch}>
                        <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                      </Button>
                    </div>
                  </div>
                </div>
              </Box>
            </div>

            <div className="mobile_serach" style={{display:"none"}}>
              <Button style={{width:"100%",marginBottom:"10px"}} variant="contained" color="secondary" onClick={handleClickOpen}>
                {t('message.common.text.search.category.open')}
              </Button>
              <Dialog className="mobile_serach_box" disableEscapeKeyDown open={open} onClose={handleClose}>
                <DialogTitle>{t('message.common.text.search.category.select')}</DialogTitle>
                <DialogContent>
                    <Box component="form">
                      <div>
                        <div>
                          {equipmentCategorySearchPermission && equipmentCategoryLevel1s && 
                          <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                              key={equipmentCategoryLevel1Id}
                              label={t('message.common.subtitle.equipment.level1')}
                              labelName={t('message.common.subtitle.equipment.level1')}
                              name={'level1'}
                              defaultValue={equipmentCategoryLevel1Id}
                              onChange={(e)=>{
                                setEquipmentCategoryLevel1Id(e.target.value);
                                setEquipmentCategoryLevel2Id('');
                                setEquipmentCategoryLevel3Id('');
                              }}
                              list={equipmentCategoryLevel1s}
                          />
                          </FormControl>
                          }
                          {equipmentCategorySearchPermission && equipmentCategoryLevel2s && 
                          <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                              key={equipmentCategoryLevel2Id}
                              label={t('message.common.subtitle.equipment.level2')}
                              labelName={t('message.common.subtitle.equipment.level2')}
                              name={'level2'}
                              defaultValue={equipmentCategoryLevel2Id}
                              onChange={(e)=>{
                                setEquipmentCategoryLevel2Id(e.target.value);
                                setEquipmentCategoryLevel3Id('');
                              }}
                              list={equipmentCategoryLevel2s}
                          />
                          </FormControl>
                          }
                          {equipmentCategorySearchPermission && equipmentCategoryLevel3s && 
                          <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                              key={equipmentCategoryLevel3Id}
                              label={t('message.common.subtitle.equipment.level3')}
                              labelName={t('message.common.subtitle.equipment.level3')}
                              name={'level3'}
                              defaultValue={equipmentCategoryLevel3Id}
                              onChange={(e)=>{
                                setEquipmentCategoryLevel3Id(e.target.value);
                              }}
                              list={equipmentCategoryLevel3s}
                          />
                          </FormControl>
                          }
                          <div style={{display:"inline-block"}}>
                          {searchFields && 
                          <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                              key={searchField}
                              label={t('message.common.btn.search')}
                              labelName={t('message.common.btn.search')}
                              name={'searchField'}
                              defaultValue={searchField}
                              onChange={(e)=>{
                                setSearchField(e.target.value);
                              }}
                              list={searchFields}
                          />
                          </FormControl>
                          }
                            <FormControl sx={{ m: 1 }} variant="standard">
                              <BootstrapInput id="demo-customized-textbox" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleMobileOnKeyPress}/>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </Box>
                    </DialogContent>
                  <DialogActions>
                    <Button onClick={handleMobileSearch} variant="contained">{t('message.common.btn.search')}</Button>
                    <Button onClick={handleClose} variant="contained" color="secondary">{t('message.common.btn.cancel')}</Button>
                  </DialogActions>
                </Dialog>
            </div>
          </div>
        </div>

        <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
          <DataGridPro
            rows={equipments && equipments !== undefined ? equipments : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />
          
          <div className="btn_right" style={{justifyContent:"space-between"}}>
            <div>
              <InspectionModal onRefresh={requestRefresh} />
              <span style={{marginLeft:"10px"}}></span>
              <MaintenanceTaskAndAlertModal onRefresh={requestRefresh} />
            </div>

            <div style={{display: "flex",justifyContent: "flex-end"}}>
              <div className='no-print-page'>
                  <CommonLargeExcelDownload 
                      title={excelTitle}
                      excelHeader={excelTopHeaders}
                      excelParam={excelParam}
                      fetchApiFn={getEquipmentsByQuery} // 👈 액시오스 함수 매핑
                      mappingFn={dataMappingRules}               // 👈 파싱 룰 데이터 매핑
                      apiKey="equipments"                          // 👈 JSON 응답 타겟 키 지정
                      pageSize={5000}                                   // 백엔드 제한 수치 수용
                      totalCount={pageInfo.totalElements}
                    />
              </div>
            </div>
          </div>
          
          <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
        </Box>

      </div>
    );
  // }
}

export default EquipmentMonitoring;